export const getAgencySynchronizerLogsUrl = () => 'agency/synchronizer_logs';

export const getAgencySynchronizedItemsUrl = (synchronizerLogId: number | string) =>
  `agency/synchronizer_logs/${synchronizerLogId}/synchronized_items`;
